<template>
  <div>
    <vxe-grid
      size="small"
      ref="table"
      resizable
      auto-resize
      highlight-hover-row
      cell-class-name="align-top"
      :toolbar-config="tableToolbar"
      :data="tableData"
      :columns="tableColumns"
      :loading="loading"
      :height="tableHeight"
      row-id="hxPurchaseDetailCode"
      :seq-config="{ startIndex: (tablePage.curPage - 1) * tablePage.pageSize }"
      :checkbox-config="{ highlight: true, reserve: true }"
      @checkbox-change="checkboxChange"
      @checkbox-all="checkboxChange"
      @cell-click="cellClick"
    >
      <template v-slot:toolbar_form>
        <slot name="header"></slot>
      </template>
      <template v-slot:toolbar_btn>
        <slot name="toolbar_btn"></slot>
      </template>
      <template v-slot:pager>
        <slot name="pager"></slot>
      </template>
      <template v-slot:status="{ row }">
        <div class="m-0">
          <el-tag
            size="mini"
            :type="
              row.hxPurchaseStatus === 'D' || row.hxPurchaseStatus === 'R'
                ? 'danger'
                : row.hxPurchaseStatus === 'Y'
                ? 'success'
                : row.hxPurchaseStatus === 'S'
                ? 'warning'
                : ''
            "
          >
            {{ row.v_hxPurchaseStatus }}
          </el-tag>
        </div>
      </template>
      <template v-slot:opt="{ row }">
        <div style="text-align: center">
          <el-dropdown trigger="click" @command="optCommand">
            <span class="el-dropdown-link">
              {{ $l('INDEX.choose_fabric_function') || '功能' }}
              <i class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item
                v-for="(opt, index) in tableOpts"
                :key="index"
                :icon="opt.icon"
                :command="{ opt, data: row }"
                :divided="opt.divided"
                :disabled="
                  opt.disabled == undefined ? false : opt.disabled(row)
                "
              >
                {{ opt.text }}
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </template>
      <template v-slot:defaultImageUrl="{ row }">
        <el-image
          :src="row.defaultImageUrl || '/image/static/img/nopic.jpg'"
          :preview-src-list="[
            row.defaultImageUrl || '/image/static/img/nopic.jpg',
          ]"
          style="width:60px;height:60px;"
        >
          <div slot="error" class="image-slot">
            <img src="/image/static/img/nopic.jpg" style="width:60px;height:60px;" />
          </div>
        </el-image>
      </template>
      <template v-slot:displayName="{ row }">
        <div class="m-0">
          <div>{{ row.goodsName }}</div>
          <div>{{ row.goodsNameEn }}</div>
          <div v-if="row.goodsSize">
            <span class="mr-1">SIZE:</span>
            <span>{{ row.goodsSize }}</span>
          </div>
          <div v-if="row.goodsColor || row.goodsColorEn">
            <span class="mr-1">COLOR:</span>
            <span>{{ row.goodsColor }}{{ row.goodsColorEn }}</span>
          </div>
        </div>
      </template>
      <template v-slot:displayNo="{ row }">
        <div class="m-0">
          <div v-if="row.brandName">
            <span class="mr-1">BRAND:</span>
            <span>{{ row.brandName }}</span>
          </div>
          <div>
            <span class="mr-1">SKU:</span>
            <span>{{ row.hxSkuNo }}</span>
          </div>
        </div>
      </template>
      <template v-slot:displayFactory="{ row }">
        <span>NC：{{ row.ncNo }}</span>
        <br />
        <span>{{ row.scmName }}</span>
      </template>
      <template v-slot:displayIsAllShipments="{ row }">
        <el-tag
          v-if="row.isAllShipments"
          size="mini"
          :type="row.isAllShipments === 'Y' ? 'success' : 'warning'"
        >
          {{ row.v_isAllShipments || '未配置' }}
        </el-tag>
      </template>
      <template v-slot:empty="{}">
        <div style="text-align: center">
          <img src="/image/static/img/nodata.png" />
          <p class="no-data">
            {{ $l('INDEX.tips_no_data') || '暂无数据！' }}
          </p>
        </div>
      </template>
    </vxe-grid>
  </div>
</template>
<script>
import TableAutoHeight from '@/mixins/table-auto-height'
import EditLoading from '@/mixins/edit-loading'
import tableColumns from './table-columns'
import tableOpts from './table-opts'
import { format } from '@/libs/util.number.js'
export default {
  mixins: [TableAutoHeight, EditLoading],
  props: {
    tableData: { type: Array, default: () => [] },
    tablePage: { type: Object, default: () => {} },
    loading: { type: Boolean, default: false },
  },
  data() {
    return {
      tableToolbar: {
        slots: { buttons: 'toolbar_form', tools: 'toolbar_btn' },
        refresh: { query: () => this.$emit('reload') },
        zoom: true,
        custom: true,
      },
      format: (n) => format(n),
      tableColumns: tableColumns(this),
    }
  },
  computed: {
    tableOpts() {
      const opts = tableOpts(this)
      return opts.filter(({ allow }) => (!allow ? true : this.allow(allow)))
    },
  },
  methods: {
    optCommand({ opt, data }) {
      const { menuType } = opt
      switch (menuType) {
        case 'updateShipped':
          this.$emit('updateShipped', data)
          break
      }
    },
    checkboxChange({ records, reserves }) {
      this.$emit('checkbox-change', records.concat(reserves))
    },
    clearCheckboxRow() {
      this.$refs.table.clearCheckboxRow()
      this.$refs.table.clearCheckboxReserve()
      this.$emit('checkbox-change', [])
    },
    cellClick({ row, column }) {
      const { property } = column
      const filterColumns = ['checkbox', 'col-opt', 'defaultImageUrl']
      if (filterColumns.includes(property)) return

      const $table = this.$refs.table
      $table.toggleCheckboxRow(row)

      const data = $table
        .getCheckboxRecords(true)
        .concat($table.getCheckboxReserveRecords(true))
      this.$emit('checkbox-change', data)
    },
  },
}
</script>
<style lang="scss" scoped>
::v-deep {
  .vxe-cell {
    > div {
      margin-top: 7px;
    }
  }
  .vxe-table--render-default .vxe-body--row:first-child .vxe-cell--valid {
    top: initial;
    padding-top: 4px;
  }
  .col-opt {
    padding-top: 0 !important;
  }
  .col--seq {
    padding-top: 11px !important;
  }
  .el-tag--confirm {
    background-color: #f9f0ff !important;
    border-color: #d3adf7 !important;
    color: #732ed1 !important;
  }
}
</style>
